import { render, staticRenderFns } from "./AfterSaleServiceAppointments.vue?vue&type=template&id=2d517e6b&"
import script from "./AfterSaleServiceAppointments.vue?vue&type=script&lang=js&"
export * from "./AfterSaleServiceAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports